module.exports = __webpack_public_path__ + "static/media/torandae.b6d8b0c0.jpg";